import NavBar from "../NavBar/NavBar";

const Header = () => {
    return (
        <header>
            <NavBar isFooter={true}/>
        </header>
    );
}

export default Header;